import { render, staticRenderFns } from "./SecurityFeature.vue?vue&type=template&id=51c8459c&scoped=true&"
import script from "./SecurityFeature.vue?vue&type=script&lang=js&"
export * from "./SecurityFeature.vue?vue&type=script&lang=js&"
import style0 from "./SecurityFeature.vue?vue&type=style&index=0&id=51c8459c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c8459c",
  null
  
)

export default component.exports